import Emphasis from './Emphasis.component';

export default Emphasis;
